module.exports = __webpack_public_path__ + "static/media/united-arab-emirates.61f9f9f9.svg";